<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiDomain } from "@mdi/js";
export default {
  name: "MdiDomain",
  data() {
    return {
      svgPath: mdiDomain,
    };
  },
};
</script>
